import { getBulkAltImageSuggestions } from '@wix/ambassador-promote-seo-v1-alt-text-suggestions/http';
export const fetchBulkAltTextSuggestions = async (httpClient, request) => {
  try {
    const {
      data
    } = await httpClient.request(getBulkAltImageSuggestions(request));
    return data.altTextSuggestions || [];
  } catch (error) {
    var _response$data;
    throw new Error(error == null || (_response$data = error.response.data) == null || (_response$data = _response$data.details) == null || (_response$data = _response$data.applicationError) == null ? void 0 : _response$data.code);
  }
};
//# sourceMappingURL=fetch-bulk-alt-text-suggestions.js.map